import { render, staticRenderFns } from "./v0.vue?vue&type=template&id=84b4c056&scoped=true&"
import script from "./v0.vue?vue&type=script&lang=js&"
export * from "./v0.vue?vue&type=script&lang=js&"
import style0 from "./v0.vue?vue&type=style&index=0&id=84b4c056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b4c056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84b4c056')) {
      api.createRecord('84b4c056', component.options)
    } else {
      api.reload('84b4c056', component.options)
    }
    module.hot.accept("./v0.vue?vue&type=template&id=84b4c056&scoped=true&", function () {
      api.rerender('84b4c056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/merchant-dashboard/v0.vue"
export default component.exports